import React from 'react'

import { trackedClick } from '../../utils'

const CustomModelOnly = ({ provider, href }) => (
    <div className="try-intento__input-control animate-appear">
        To use this provider, let us access your model as described in the{' '}
        <a
            href={href}
            onClick={trackedClick('Go to Web tools', {
                source: 'TryError',
                title: provider.name,
            })}
        >
            Developer Console
        </a>
        .
    </div>
)

export default CustomModelOnly



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/TryError/CustomModelOnly.jsx